<script>
import { Link } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['links'],
      availableWidgets: []
    }
  },
  mounted() {
    this.fetchAvailableWidgets()
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          fields: [
            ...this.getCommonFields(),
            new fields.Header({
              text:
                'Do wyboru dostępne są jedynie widgety uprzednio zapisane na stronie.',
              type: 'h6'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'links'],
              items: this.form.links.map((item, i) => ({
                headerLabel: get(item, ['label_pl']),
                fields: [
                  new fields.Input({
                    label: 'Tekst na odnośniku',
                    required: true,
                    modelPath: [this, 'form', 'links', i, 'label'],
                    multilingual: true
                  }),
                  new fields.Select({
                    label: 'Widget',
                    required: true,
                    modelPath: [this, 'form', 'links', i, 'widget'],
                    options: this.availableWidgets
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  },
  methods: {
    fetchAvailableWidgets() {
      const id = this.$route.params.id
      Link.availableWidgets({ basepage_pk: id }).then(res => {
        this.availableWidgets = res.data
      })
    }
  }
}
</script>
